import React, { useCallback } from 'react';
import { Cell, Button } from 'react-mdl';

const GeoLocation = (props) => {
    const onRetry = useCallback(() => {
        navigator.geolocation.getCurrentPosition(async function(pos) {
            props.history.goBack()
        }, function(error) {
            alert("You need to enable location service manually in the browser setting.")
            props.history.goBack()
        })
    }, [props.history])
    return (
        <div className="page-container text-center align-center flex-vertical justify-center geo-location">
            <Cell col={12}>
                <p className="page-title">Oops!</p>
            </Cell>
            <Cell col={12}>
                <p className="page-description">You need to enable location service on this App to continue.</p>
            </Cell>
            <Cell col={12}>
                <Button className="color--brown" onClick={onRetry}>Retry</Button>
            </Cell>
        </div>
    )
}

export default GeoLocation;